import React from "react";
import Post from "../Post";
import PostModel from "app/models/PostModel";
import useTimelinePostsContainerModel from "./indexModel";
// import ScheduledPostsCounter from "../ScheduledPosts/ScheduledPostsCounter";
import NoPosts from "../NoResults/NoPosts";
import { Loading } from "../Wrappers";

export interface TimelinePostContainerProps {
  displayPostLocations?: boolean;
  hidePinBadge?: boolean;
  no_posts_title?: string;
  no_posts_description?: string;
  no_posts_image?: string;
  no_posts_className?: string;
  posts?: PostModel[];
  onReport?: (post: PostModel) => void;
  onPostDelete?: (post: PostModel) => void;
  onPostUpdate?: (post: PostModel) => void;
  canPinPost?: boolean;
  onPostPin?: () => void;
  containerRef?: any;
  pending?: boolean;
  hideReply?: boolean;
  hideLikes?: boolean;
}

const TimelinePostsContainer: React.FC<TimelinePostContainerProps> = ({
  displayPostLocations,
  hidePinBadge,
  no_posts_title,
  no_posts_description,
  no_posts_image,
  no_posts_className,
  posts,
  onReport,
  onPostDelete,
  onPostUpdate,
  canPinPost,
  onPostPin,
  containerRef,
  pending,
}: TimelinePostContainerProps) => {
  const { self } = useTimelinePostsContainerModel();

  if (!self) {
    return null;
  }

  if (posts?.length === 0) {
    if (!pending) {
      return (
        <NoPosts
          title={no_posts_title}
          image={no_posts_image}
          description={no_posts_description}
          className={no_posts_className}
        />
      );
    } else {
      return <Loading isLoading loadType="spinner" />;
    }
  }

  return (
    <>
      {posts?.map((post: PostModel) => {
        return (
          <Post
            key={post.id}
            post={post}
            user={self}
            onEdit={onPostUpdate}
            onEditTags={onPostUpdate}
            onRemove={onPostDelete}
            onPin={onPostPin}
            onReport={onReport}
            hidePinBadge={hidePinBadge}
            displayLocation={displayPostLocations}
            canPinPost={canPinPost}
          />
        );
      })}
      {pending && posts?.length > 0 && <Loading isLoading loadType="spinner" />}
      <div ref={containerRef} />
    </>
  );
};

export default TimelinePostsContainer;
